export enum SeatAvailabilityEnum {
    Open = "Open",
    ReservedForPnr = "ReservedForPnr",
    CheckedIn = "CheckedIn",
    HeldForThisSession = "HeldForThisSession"
}
